module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaBAMAAABFrWFOAAAAJFBMVEVBiNBBiNBBiNBBiNDt8POuyudIjNHm7PLQ3u2Cr91fmtZdmdYMJElTAAAAA3RSTlPmSklSjzZ3AAAAQElEQVQY02NQMIYCJgZmGNOAwRgOqMQ0C4YzdzjDmJYlMKZZiIuLC4Rp6gIEGKIItUCwwhnNXModiex5ARiTEQAMNDXQeoO6vwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_previous_hover.png
// module id = qYap
// module chunks = 9